export default __webpack_public_path__ + "static/media/bg4_1_m.16fff674.png";